import React from "react";

const AutomaticInformation = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          3. COLLECTION OF AUTOMATIC INFORMATION, USE OF COOKIES AND OTHER
          TRACKING DEVICES
        </h1>
        We and our third party service providers, which include ad networks, use
        Cookies, web beacons, and other tracking technologies to collect
        information about your use of our Platform and Services, such as your
        browser type, your ISP or operating system, your domain name, your
        access time, the URL of the previous website you visited, your page
        views, your IP address, and the type of device that you use. We also
        track how frequently you visit our Platform and use our Services. We use
        this information (including the information collected by our third party
        service providers) for Website analytics (including to determine which
        portions of our Platform are used most frequently, what our users
        like/do not like), to assist us in determining relevant advertising
        (both on and off our Platform), to evaluate the success of our
        advertising campaigns, and as otherwise described in this policy. We may
        obtain your device ID, which is sent to Yostel’s servers and used in
        fraud prevention efforts.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        Cookies.
        <br /> We and our third-party service providers collect information from
        you by using Cookies. A Cookie is a small file stored on the user's
        computer hard drive containing information about the user. The Cookie
        helps us analyze web traffic or informs you about your use of a
        particular website. Cookies allow web applications to respond to you as
        an individual, tailoring its operations to your needs, likes and
        dislikes by gathering and remembering information about your
        preferences. When you visit the Platform, we may send one or more
        Cookies (i.e., a small text file containing a string of alphanumeric
        characters) to your computer that identifies your browser.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        Some of these Cookies may be connected to third-party companies or
        websites. The terms of use of such Cookies are governed by this Policy
        and the privacy policy of the relevant third-party company or website.
        For example, Google measures the performance of advertisements by
        placing Cookies on your computer when you click on ads. If you visit the
        Platform when you have such Cookies on your computer, we and Google will
        be able to tell that you saw the ad delivered by Google. The terms of
        use of these Cookies are governed by this Policy and Google's Privacy
        Policy.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        Disabling Cookies.
        <br /> You can choose to accept or decline Cookies. Most web browsers
        automatically accept Cookies, but you can usually modify your browser
        setting to decline Cookies if you prefer. If you disable Cookies you may
        be prevented from taking full advantage of the Platform because it may
        not function properly if the ability to accept Cookies is disabled.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        Clear GIFs, pixel tags and other technologies. Clear GIFs are tiny
        graphics with a unique identifier, similar in function to Cookies. In
        contrast to Cookies, which are stored on your computer's hard drive,
        clear GIFs are embedded invisibly on web pages. We may use clear GIFs
        (a.k.a. web beacons, web bugs or pixel tags), in connection with our
        Platform to, among other things, track the activities of Platform
        visitors, help us manage content, and compile statistics about Platform
        usage. We and our third-party service providers also use clear GIFs in
        HTML emails to our customers, to help us track email response rates,
        identify when our emails are viewed, and track whether our emails are
        forwarded.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        You acknowledge that some entities and /or countries where we may
        transfer your personal information may not comply with data protection
        policies which are as stringent as the laws of India or the policies
        followed by Yostel. You acknowledge that it is adequate that when we
        transfer your personal information to any other entity within or outside
        India, we will place contractual obligations on the transferee which
        will oblige the transferee to adhere to the provisions of this Privacy
        Policy.
      </p>
    </div>
  );
};

export default AutomaticInformation;
